
import clsBaseGlobal from './base'

const arrFillable = [
    "add_summary_in_invoice",
];


class clsGlobalSalesOrders extends clsBaseGlobal {

    // From company settings edit
    add_summary_in_invoice     = false;

    get fillable() { return arrFillable; }

    fill(data) {
        data = data ||{};
        data.add_summary_in_invoice    = !!data.add_summary_in_invoice;

        return super.fill(data);
    }
}

export default clsGlobalSalesOrders;